import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export interface IVendorParent {
	vendorParentId: string;
	name: string;
	vendorId?: string | null;
}

const initialState: Array<IVendorParent> = [];

export const { thunk: getVendorParents, slice: vendorParentsSlice } = getThunkAndSlice<
	Record<string, never>,
	Array<IVendorParent>,
	Array<IVendorParent>
>({
	initialState,
	path: "/api/Vendor/vendorParents",
});
